import { EventProductMappedToTier } from 'legacy/common/types/models';
import { TFunction } from 'i18next';

/**
 * Groups tickets by section ID.
 */
export const groupTicketsBySection = (
  sortedTicketTiers: EventProductMappedToTier[]
) =>
  sortedTicketTiers?.reduce((acc, tier) => {
    const sectionId = tier.sectionId || 'default';
    acc[sectionId] = [...(acc[sectionId] || []), tier];
    return acc;
  }, {} as Record<string, EventProductMappedToTier[]>);

/**
 * Filters sections that have tickets.
 */
export const filterSectionsWithTickets = (
  sections: any[],
  ticketsBySection: Record<string, EventProductMappedToTier[]>
) => sections?.filter((section) => ticketsBySection?.[section.id]?.length > 0);

/**
 * Creates menu sections including private and uncategorized sections.
 */
export const createMenuSections = (
  privateTiers: EventProductMappedToTier[],
  filteredSections: any[],
  defaultTickets: EventProductMappedToTier[],
  t: TFunction
) => {
  const sections = [];

  if (privateTiers?.length > 0) {
    sections.push({ id: 'private', name: t('checkout:private') });
  }

  sections.push(...filteredSections);

  if (defaultTickets.length > 0 && sections.length > 0) {
    sections.push({ id: 'uncategorized', name: t('checkout:uncategorized') });
  }

  return sections;
};
